module.exports = __webpack_public_path__ + "assets/pulse_blue.808c40e2.svg";